export default __webpack_public_path__ + "static/media/logo.3dfee93a.svg";